<template>
    <div
        v-if="!error"
        class="upload-component"
        @drop.prevent="handleDrop"
        @dragover.prevent="handleDragOver"
        @dragleave.prevent="handleDragLeave"
    >
        <form class="contact-form" @submit.prevent="submit">
            <div class="container-top" :class="{ dragging: isDragging }">
                <div class="row">
                    <div class="col-xs-12">
                        <input
                            ref="file-input"
                            class="file-input"
                            @change="change"
                            id="file"
                            type="file"
                            multiple
                        />
                        <label for="file" class="dropzone-label submit">
                            <div class="dropzone-content upload-info">
                                <i class="fa fa-cloud-upload upload-logo"></i>
                                <p>Datei ablegen oder</p>
                                <div class="btn btn-green upload-button">
                                    Hier klicken
                                </div>
                                <p class="info-text-small">
                                    <strong>max. 50 MB</strong>
                                </p>
                                <p class="info-text-small">
                                    bereits hochgeladen:
                                    <strong
                                        >{{ bytesToSize(currentSize) }}
                                    </strong>
                                </p>
                                <p class="info-text-small">
                                    Erlaubte Dateiformate: .pdf, .jpeg, .jpg,
                                    .doc, .docx, .odt, .heic
                                </p>
                            </div>
                        </label>
                        <button
                            type="submit"
                            :style="
                                settings.directUploadAfterPickingFiles
                                    ? 'display: none;'
                                    : ''
                            "
                        >
                            Hochladen
                        </button>
                    </div>
                    <div class="col-xs-12 error-message">
                        {{ errorMessage }}
                    </div>
                </div>
            </div>
            <div class="container-bottom">
                <div
                    class="row item"
                    v-for="(file, index) in currentFileList"
                    :key="index"
                >
                    <div class="col-xs-7 col-md-5 container-name">
                        <div class="name">
                            <i class="fa fa-file-o"></i>
                            <span class="name">{{ file.name }}</span>
                        </div>

                        <select
                            v-model="file.documentType"
                            class="form-control"
                            style="margin-top: 12px"
                        >
                            <option value="null">
                                Dokumententyp Auswählen
                            </option>
                            <option value="anschreiben">Anschreiben</option>
                            <option value="deckblatt">Deckblatt</option>
                            <option value="lebenslauf">Lebenslauf</option>
                            <option value="sonstiges">
                                Bewerbungsanlagen (Zeugnisse / Zertifikate /
                                Sonstiges)
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-5 col-md-2 container-infos">
                        <div class="status">
                            <span>{{ file.loaded }}%</span>
                            <template v-if="file.loaded === 100">
                                <i class="fa fa-check"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-spinner fa-spin"></i>
                            </template>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-5 container-actions">
                        <div @click="remove(index)" class="delete">
                            <i class="fa fa-trash-o"></i>
                            <span>Löschen</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<style lang="scss">
@import "../scss/_vars";

.upload-component {
    background: #ffffff;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);

    .file-input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .submit {
        margin-bottom: 15px;
        position: inherit;
        left: 0;
        right: 0;
        top: 0;
        cursor: pointer;
        pointer-events: inherit;
    }

    .container-top {
        padding: 16px;
        overflow: hidden;
        background: #f8f8f8;
        height: 256px;

        input,
        button {
            display: none;
        }

        .hint {
            text-align: center;

            @media (min-width: map-get($breakpoints, "md")) {
                line-height: 60px;
            }
        }

        .error-message {
            color: red;
        }
    }

    .container-bottom {
        margin-bottom: 50px;
        padding-left: 16px;
        padding-right: 16px;
        overflow: hidden;
        background: #fff;

        .item {
            padding-top: 20px;
            padding-bottom: 20px;
            border-top: 1px solid #e0e0e0;
        }

        .container-name {
            .fa {
                padding-right: 20px;
            }
        }

        .container-infos {
            margin-bottom: 15px;
            text-align: right;

            @media (min-width: map-get($breakpoints, "md")) {
                margin-bottom: 0px;
            }

            .status {
                color: #00a7af;

                span {
                    padding-right: 6px;
                }

                .fa {
                    font-size: 16px;
                    font-weight: 300;
                }
            }
        }

        .container-actions {
            .delete {
                float: right;
                color: #00a7af;
                cursor: pointer;

                .fa {
                    padding-right: 10px;
                    font-size: 16px;
                    font-weight: 300;
                }

                span {
                    font-size: 14px;
                    font-weight: 600;
                }
            }
        }
    }

    .dragging {
        transition: background-color 0.3s ease;
        background-color: rgba(0, 167, 175, 0.3);
    }

    .content-form label {
        position: unset;
    }

    .upload-info {
        text-transform: none;

        .upload-logo {
            font-size: 24px;
            margin-bottom: 0;
        }

        p {
            margin: 0 !important;
        }

        .info-text-small {
            font-size: 14px;
        }

        .upload-button {
            line-height: 16px;
            padding: 12px;
        }
    }

    .dropzone-label {
        display: block;
        cursor: pointer;
        border: 2px dotted #00a7af;
        padding: 12px;
        position: unset;
    }

    .dropzone-content {
        text-align: center;
    }

    .dropzone-content i {
        font-size: 2em;
        margin-bottom: 10px;
    }

    .dropzone-content p {
        margin: 5px 0;
    }

    .dropzone-content .link {
        color: #00a7af;
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>

<script>
import Utility from "../libs/Utility";
import { v4 as uuidv4 } from "uuid";

export default {
    props: {
        options: Object,
        fileList: {
            type: Array,
            default() {
                return [];
            },
        },
        additionalPost: {
            type: Object,
            default() {
                return {};
            },
        },
        errorMessage: {
            type: String,
        },
    },

    data() {
        return {
            settings: {
                directUploadAfterPickingFiles: false,
                postUrl: null,
            },
            error: false,
            currentFileList: [],
            isDragging: false,
            currentSize: 0,
        };
    },

    created() {
        this.currentFileList = this.fileList;
        Utility.extend(this.settings, this.options);
        if (!this.settings.postUrl) {
            this.error = true;
        }

        for (let i = 0; i < this.currentFileList.length; i++) {
            this.currentSize += this.currentFileList[i].size;
        }
    },

    methods: {
        submit() {
            for (let i = 0; i < this.currentFileList.length; i++) {
                let formData = new FormData();
                let request = new XMLHttpRequest();
                let file = this.currentFileList[i];

                if (file.loaded === 100) {
                    continue;
                }

                formData.set("file", file.fileObj);
                formData.set("id", file.id);
                for (let key in this.additionalPost) {
                    let value = this.additionalPost[key];
                    formData.set(key, value);
                }

                request.open("POST", this.settings.postUrl);
                request.upload.onloadstart = (e) => {
                    this.$set(file, "total", e.total);
                    this.$set(file, "loaded", 0);
                    this.$forceUpdate();
                };
                request.upload.onprogress = (e) => {
                    if (e.lengthComputable) {
                        this.$set(
                            file,
                            "loaded",
                            ((e.loaded * 100) / e.total).toFixed(0)
                        );
                        this.$forceUpdate();
                    }
                };
                request.upload.onloadend = () => {
                    this.$set(file, "loaded", 100);
                    this.$forceUpdate();
                    this.$emit("uploaded", {
                        file: file,
                        fileList: this.currentFileList,
                    });

                    let allUploaded = true;
                    for (let k = 0; k < this.currentFileList.length; k++) {
                        let file2 = this.currentFileList[k];
                        if (file2.loaded !== 100) {
                            allUploaded = false;
                            break;
                        }
                    }

                    if (allUploaded) {
                        this.$emit("allUploaded", {
                            fileList: this.currentFileList,
                        });
                    }
                };
                request.upload.onerror = () => {
                    this.$set(file, "error", true);
                    this.$forceUpdate();
                };
                formData.set("action", "upload");
                request.send(formData);
            }
        },

        remove(index) {
            let formData = new FormData();
            let request = new XMLHttpRequest();

            request.open("POST", this.settings.postUrl);
            let file = this.currentFileList[index];

            let filename = file.name;
            let parts = filename.split(".");
            let name = parts.slice(0, -1).join(".");
            let ext = parts[parts.length - 1];

            formData.set("uuid", file.uuid);
            formData.set("filename", name);
            formData.set("extension", ext);

            for (let key in this.additionalPost) {
                let value = this.additionalPost[key];
                formData.set(key, value);
            }
            formData.set("action", "remove");
            this.currentSize -= file["size"];
            request.send(formData);

            this.currentFileList.splice(index, 1);
            this.$emit("remove", { fileList: this.currentFileList });
        },

        change(e) {
            this.handleFiles(e.target.files);
        },

        handleDrop(e) {
            const files = e.dataTransfer.files;
            this.isDragging = false;
            this.handleFiles(files);
        },

        bytesToSize(bytes) {
            const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

            if (bytes === 0) {
                return "0 MB";
            }

            //@ts-ignore
            const i = parseInt(
                Math.floor(Math.log(bytes) / Math.log(1024)),
                10
            );

            if (i === 0) {
                return `${bytes} ${sizes[i]})`;
            }

            return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
        },

        handleFiles(files) {
            for (let i = 0; i < files.length; i++) {
                let fileObj = files[i];

                let sameName = false;
                for (let i = 0; i < this.currentFileList.length; i++) {
                    let file = this.currentFileList[i];

                    if (file.name === fileObj.name) {
                        sameName = true;
                        break;
                    }
                }
                if (sameName) {
                    continue;
                }

                if (!((this.currentSize + fileObj.size) / 1024 / 1024 > 50)) {
                    this.currentSize += fileObj.size;

                    fileObj.id = uuidv4();

                    this.currentFileList.push({
                        name: fileObj.name,
                        lastModified: fileObj.lastModified,
                        lastModifiedDate: fileObj.lastModifiedDate,
                        size: fileObj.size,
                        type: fileObj.type,
                        id: fileObj.id,
                        fileObj: fileObj,
                        documentType: null,
                    });
                }
            }

            if (this.settings.directUploadAfterPickingFiles) {
                this.submit();
            }
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },

        handleDragOver(e) {
            this.preventDefaults(e);
            this.isDragging = true;
        },

        handleDragLeave(e) {
            this.preventDefaults(e);
            this.isDragging = false;
        },
    },
};
</script>
